module.exports = __webpack_public_path__ + "static/media/pm_tours_batiment_classe.204c16f5.jpg";